var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-title" }, [
        _c("span", { staticStyle: { "text-transform": "capitalize" } }, [
          _vm._v(
            _vm._s(
              _vm.$tc(_vm.selectedObject.type, 1) +
                " " +
                _vm.selectedObject.index +
                " | " +
                _vm.$tc("Floorbox", 2)
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          dense: "",
          "hide-default-footer": "",
          "disable-sort": "",
          headers: _vm.headers
        },
        scopedSlots: _vm._u(
          [
            !_vm.actionTypeIsView
              ? {
                  key: "header.addButton",
                  fn: function() {
                    return [
                      _c("thead", [
                        _c(
                          "th",
                          { staticStyle: { "padding-left": "30%" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "add-button",
                                attrs: { "x-small": "", depressed: "" },
                                on: { click: _vm.openDialog }
                              },
                              [
                                _c("v-icon", { attrs: { color: "#4fa2b7" } }, [
                                  _vm._v("add_box")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "body",
              fn: function() {
                return [
                  _c(
                    "tbody",
                    _vm._l(_vm.floorboxs, function(item, itemIndex) {
                      return _c(
                        "tr",
                        { key: itemIndex, staticClass: "cursor-pointer" },
                        _vm._l(_vm.headers, function(header) {
                          return _c(
                            "td",
                            {
                              key: header.value,
                              class: header.value,
                              style: {
                                padding:
                                  header.text === "" ? "4px" : "0 0 0 18px"
                              },
                              attrs: { title: item[header.value] }
                            },
                            [
                              header.value === "floorbox_label" &&
                              !!item[header.value]
                                ? _c("div", {
                                    staticClass: "floorbox-icon",
                                    staticStyle: { "margin-right": "5px" },
                                    style: {
                                      "background-color": item.floorbox_color
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              header.text === _vm.$tc("Floor", 1)
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getFloorNumber(item[header.value])
                                      )
                                    )
                                  ])
                                : header.text === _vm.$t("Column")
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getColumnIndex(
                                          item[header.value],
                                          _vm.columns
                                        )
                                      )
                                    )
                                  ])
                                : header.text === _vm.$t("Cable-inReference")
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getCableInReference(
                                          item[header.value]
                                        )
                                      )
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(item[header.value]))
                                  ]),
                              _vm._v(" "),
                              header.text === ""
                                ? _c("div", {
                                    staticClass: "floorbox-icon",
                                    style: { "background-color": item.color }
                                  })
                                : header.text === "Active"
                                ? _c(
                                    "div",
                                    [
                                      _c("v-simple-checkbox", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: item.active,
                                          callback: function($$v) {
                                            _vm.$set(item, "active", $$v)
                                          },
                                          expression: "item.active"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : !header.text
                                ? _c(
                                    "div",
                                    [
                                      _c("app-datatable-action-buttons", {
                                        attrs: {
                                          "has-closure": !!item.closure,
                                          "is-floorbox": true,
                                          "user-can-edit": true,
                                          "user-can-delete": true
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.editItem(item, itemIndex)
                                          },
                                          delete: function($event) {
                                            return _vm.askConfirmationToDeleteItem(
                                              item
                                            )
                                          },
                                          "open-floorbox": function($event) {
                                            return _vm.openFloorboxTab(item)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    }),
                    0
                  )
                ]
              },
              proxy: true
            },
            {
              key: "no-data",
              fn: function() {
                return [_vm.loading ? _c("div") : _vm._e()]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("planning-details-table-buttons", {
        attrs: {
          "object-type": _vm.selectedObject.type,
          "action-type": _vm.actionType
        },
        on: {
          "delete-item": function($event) {
            return _vm.askConfirmationToDeleteItem(_vm.selectedObject)
          }
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteItem"),
          content: _vm.$t("DeleteConfirmation") + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: _vm.closeDeleteDialog,
          secondaryAction: _vm.deleteItem
        }
      }),
      _vm._v(" "),
      _vm.floorboxFormIsOpen
        ? _c("floorbox-form", {
            attrs: {
              "dialog-is-open": _vm.floorboxFormIsOpen,
              "object-to-edit": _vm.itemToEdit.data,
              "floorbox-colors": _vm.floorboxColors,
              floors: _vm.groundFloors.concat(_vm.undergroundFloors),
              columns: _vm.columns,
              "technical-locals": _vm.technicalLocals,
              selectedObject: _vm.selectedObject,
              cableTypeSixOptions: _vm.cableTypeSixOptions,
              cableTypeFiveOptions: _vm.cableTypeFiveOptions
            },
            on: {
              "close-dialog": _vm.closefloorboxForm,
              "create-floorbox": function($event) {
                return _vm.$emit("create-floorbox", $event)
              },
              "edit-floorbox": function($event) {
                return _vm.saveObject($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3761f222", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3761f222","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FloorboxesTable.vue
// module id = null
// module chunks = 